import type { IPlaceholderConfig, ITemplatePageConfig } from '~/types/template'

import BackgroundImageBlock from '~/components/DynamicScreen/Blocks/BackgroundImage'
import ButtonBlock from '~/components/DynamicScreen/Blocks/Button'
import SubTitleBlock from '~/components/DynamicScreen/Blocks/SubTitle'
import TextBlock from '~/components/DynamicScreen/Blocks/Text'
import TitleBlock from '~/components/DynamicScreen/Blocks/Title'

const placeholders: IPlaceholderConfig[] = [
  {
    category: 'arguments',
    component: TitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'title_txt_1',
    previewProperties: {
      text: 'Marketing argument for the first slide.',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'arguments',
    component: SubTitleBlock,
    defaultValue: { color: '#2E2F31' },
    placeholderKey: 'subtitle_txt_1',
    previewProperties: {
      text: 'Subheading arguments for the first slide of the onboarding. Can be up to 150 characters long. Be careful with your Lokalise translation',
    },
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    className: 'button-text',
    component: TextBlock,
    defaultValue: { color: '#FFFFFF', translation: 'common.continue' },
    placeholderKey: 'continue_txt_1',
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    component: ButtonBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'action_next_cta_1',
    type: ['color'],
  },
]

export const marketingPage1: ITemplatePageConfig = {
  backgroundImage: 'background_img_1',
  className: 'page-1',
  name: '1. Marketing',
  placeholders: [
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_img_1',
      type: 'asset',
    },
  ],
}

export const marketingPage1Video: ITemplatePageConfig = {
  ...marketingPage1,
  backgroundImage: 'background_video_1',
  placeholders: [
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_video_1',
      type: 'asset',
    },
  ],
}
